/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { EgridMeta } from './egridMeta';
import { GbGeschaeftId } from './gbGeschaeftId';
import { HistInfoMeta } from './histInfoMeta';
import { GrundstueckId } from './grundstueckId';
import { CodeEntryMeta } from './codeEntryMeta';
import { GeometerGeschaeftIdMeta } from './geometerGeschaeftIdMeta';
import { GrundstueckListEntryMeta } from './grundstueckListEntryMeta';
import { GrundstueckNummerListEntry } from './grundstueckNummerListEntry';
import { GrundstueckPermissions } from './grundstueckPermissions';


export interface GrundstueckDetailEntryMeta { 
    modificationCounter?: number;
    mModificationCounter?: FieldMetaData;
    id: GrundstueckId;
    mId?: FieldMetaData;
    haengigeAvGeschaefteIds?: Array<GeometerGeschaeftIdMeta>;
    mHaengigeAvGeschaefteIds?: FieldMetaData;
    codeUnterart?: CodeEntryMeta;
    mCodeUnterart?: FieldMetaData;
    eidgenoessischSeit?: string;
    mEidgenoessischSeit?: FieldMetaData;
    anzahlHaengigeAuftraege?: number;
    mAnzahlHaengigeAuftraege?: FieldMetaData;
    anzahlHaengigeAvGeschaefte?: number;
    mAnzahlHaengigeAvGeschaefte?: FieldMetaData;
    grundstueckNummern?: Array<GrundstueckNummerListEntry>;
    mGrundstueckNummern?: FieldMetaData;
    grundstueckRTFpossible?: boolean;
    mGrundstueckRTFpossible?: FieldMetaData;
    egrid?: EgridMeta;
    mEgrid?: FieldMetaData;
    sdrArt?: GrundstueckDetailEntryMeta.SdrArtEnum;
    mSdrArt?: FieldMetaData;
    anzahlHaengigeGbGeschaefte?: number;
    mAnzahlHaengigeGbGeschaefte?: FieldMetaData;
    alpgrundstuecke?: Array<GrundstueckListEntryMeta>;
    mAlpgrundstuecke?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    ligArt?: GrundstueckDetailEntryMeta.LigArtEnum;
    mLigArt?: FieldMetaData;
    dokulinkVerfuegbar?: GrundstueckDetailEntryMeta.DokulinkVerfuegbarEnum;
    mDokulinkVerfuegbar?: FieldMetaData;
    permissions?: GrundstueckPermissions;
    mPermissions?: FieldMetaData;
    grundbuchFuehrung?: GrundstueckDetailEntryMeta.GrundbuchFuehrungEnum;
    mGrundbuchFuehrung?: FieldMetaData;
    grundstueckPDFpossible?: boolean;
    mGrundstueckPDFpossible?: FieldMetaData;
    geloeschtDatum?: Date;
    mGeloeschtDatum?: FieldMetaData;
    grundstueckArt?: GrundstueckDetailEntryMeta.GrundstueckArtEnum;
    mGrundstueckArt?: FieldMetaData;
    isKopie?: boolean;
    mIsKopie?: FieldMetaData;
    haengigeGbGeschaefteIds?: Array<GbGeschaeftId>;
    mHaengigeGbGeschaefteIds?: FieldMetaData;
    flaechenMaessigNichtAusgeschieden?: boolean;
    mFlaechenMaessigNichtAusgeschieden?: FieldMetaData;
}
export namespace GrundstueckDetailEntryMeta {
    export type SdrArtEnum = 'BAURECHT' | 'QUELLENRECHT' | 'KONZESSION' | 'UEBRIGES_RECHT';
    export const SdrArtEnum = {
        BAURECHT: 'BAURECHT' as SdrArtEnum,
        QUELLENRECHT: 'QUELLENRECHT' as SdrArtEnum,
        KONZESSION: 'KONZESSION' as SdrArtEnum,
        UEBRIGES_RECHT: 'UEBRIGES_RECHT' as SdrArtEnum
    };
    export type LigArtEnum = 'STR' | 'CFA' | 'DPI' | 'VEC' | 'VIC' | 'ADG' | 'UEBRIGEART';
    export const LigArtEnum = {
        STR: 'STR' as LigArtEnum,
        CFA: 'CFA' as LigArtEnum,
        DPI: 'DPI' as LigArtEnum,
        VEC: 'VEC' as LigArtEnum,
        VIC: 'VIC' as LigArtEnum,
        ADG: 'ADG' as LigArtEnum,
        UEBRIGEART: 'UEBRIGEART' as LigArtEnum
    };
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        DOKULINK_VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        DOKULINK_NICHT_VORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
    export type GrundbuchFuehrungEnum = 'EIDGENOESSISCH' | 'KANTONAL' | 'BEREINIGUNG' | 'EINFUEHRUNG';
    export const GrundbuchFuehrungEnum = {
        EIDGENOESSISCH: 'EIDGENOESSISCH' as GrundbuchFuehrungEnum,
        KANTONAL: 'KANTONAL' as GrundbuchFuehrungEnum,
        BEREINIGUNG: 'BEREINIGUNG' as GrundbuchFuehrungEnum,
        EINFUEHRUNG: 'EINFUEHRUNG' as GrundbuchFuehrungEnum
    };
    export type GrundstueckArtEnum = 'STOCKWERK' | 'LIEGENSCHAFT' | 'MITEIGENTUM' | 'UNBEKANNT' | 'FOLIO' | 'BERGWERK' | 'SDR';
    export const GrundstueckArtEnum = {
        STOCKWERK: 'STOCKWERK' as GrundstueckArtEnum,
        LIEGENSCHAFT: 'LIEGENSCHAFT' as GrundstueckArtEnum,
        MITEIGENTUM: 'MITEIGENTUM' as GrundstueckArtEnum,
        UNBEKANNT: 'UNBEKANNT' as GrundstueckArtEnum,
        FOLIO: 'FOLIO' as GrundstueckArtEnum,
        BERGWERK: 'BERGWERK' as GrundstueckArtEnum,
        SDR: 'SDR' as GrundstueckArtEnum
    };
}


